import React from 'react';

interface TimeIconProps {
  size?: number;
  color?: string;
}

export const TimeIcon: React.FC<TimeIconProps> = ({ 
  size = 32, 
  color = '#009951' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 32 32"
    >
      <g clipPath="url(#a)">
        <path 
          fill={color} 
          d="M16 1.778a14.222 14.222 0 1 0 0 28.445 14.222 14.222 0 0 0 0-28.445m5.51 18.827a.89.89 0 0 1-1.235.248l-5.244-3.555V9.556a.889.889 0 1 1 1.777 0v6.8l4.445 3.013a.89.89 0 0 1 .258 1.236m-.31-13.29a10.125 10.125 0 1 0-7.591 18.516l-.276 1.396a11.555 11.555 0 1 1 8.622-21.13z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h32v32H0z"/>
        </clipPath>
      </defs>
    </svg>
  );
};

